// extracted by mini-css-extract-plugin
export default {"container":"BackButton_container__PsA64","icon":"BackButton_icon__yQYr7"};